module.exports = __webpack_public_path__ + "static/media/bd-hsca-hsia-hackensack-meridian-case-study.821d3185.pdf";